import React from 'react'
import {Link} from "@mui/material";

const Logo = (props) => {
    return (
        <Link href="/">
            <img src="/assets/famtrail-logo-full.svg"
                 alt="Famtrail"
                 style={props.style}
            />
        </Link>
    )
}

export default Logo